import React from "react";
import { formatAmount } from "../../../features/ValueFormater";
import BankBalanceStatus from "../Common/BankBalanceStatus";

export default function BalanceCard({
  title,
  currency,
  total,
  available,
  book,
  held,
  connectionState,
  lastBalanceDate,
}) {
  return (
    <article className="new-bank-overview__card new-bank-overview__balance-card">
      <div className="new-bank-overview__balance-head">
        <span>{title}</span>
        <strong>{formatAmount(total, currency)}</strong>
      </div>

      <BankBalanceStatus state={connectionState} lastBalanceDate={lastBalanceDate} />

      <div className="new-bank-overview__balance-divider" />

      <div className="new-bank-overview__balance-stats">
        <div className="new-bank-overview__stat">
          <strong>{formatAmount(available, currency)}</strong>
          <span>Available</span>
        </div>
        <div className="new-bank-overview__stat">
          <strong>{formatAmount(book, currency)}</strong>
          <span>Book</span>
        </div>
        <div className="new-bank-overview__stat">
          <strong>{formatAmount(held, currency)}</strong>
          <span>Hold</span>
        </div>
      </div>
    </article>
  );
}
